import React, { useState, useEffect } from "react";

const Pagetrans = ({ className, children }) => {
  const [slide, setSlide] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setSlide(false);
    }, 0);
    return () => {
      clearTimeout(t);
      setSlide(true);
    };
  }, []);

  return (
    <div
      className={`${className || ""} slide-in-done ${slide ? "slide-in" : ""}`}
    >
      {children}
    </div>
  );
};

export default Pagetrans;
